export enum WorldCustomsOrganizationMessageMessageType {
  CUSTOMS_DECLARATION = 'CUSTOMS_DECLARATION',
}

export enum HmrcPartner {
  DESTIN_8 = 'DESTIN_8',
}
